import { isNilOrEmpty } from '../../../utils/ramdaUtils';

export const getDropDownOptions = ({
  multiSelect,
  options,
  value,
  multiSelectValues,
  dataValueField,
  dataTextField,
}) => {
  if (multiSelect) {
    const externalValues = multiSelectValues.filter(
      (val) => !options.some((item) => item[dataValueField] === val)
    );

    return [
      ...externalValues.map((val) => ({ [dataValueField]: val, [dataTextField]: val })),
      ...options,
    ];
  }

  const isCurrentValueInOptions = options.some((item) => item[dataValueField] === value);
  const allValues =
    isCurrentValueInOptions || isNilOrEmpty(value)
      ? options
      : [{ [dataValueField]: value, [dataTextField]: value }, ...options];

  return allValues;
};
